export enum SignUpType {
    Startup = "startup",
    Corporate = "corporate"
}